import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Helmet } from '@/common/components/Helmet'
import SurveyConfirmation from '@/features/surveys/components/SurveyConfirmation'
import { useSurveyPreview } from '../-context'
import { isValidLanguageId, languageObject } from '@/common/classes/LanguageUtils'
import { titleTagSuffix } from '@/common/constants'
import { Store } from '@/store/Store'

export const Route = createFileRoute(
  '/app/survey-previews/$surveyId/$languageId/confirmation',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { languageId } = Route.useParams()
  const { survey } = useSurveyPreview()

  const [effectiveLanguageId, setEffectiveLanguageId] = useState<string | null>(
    null,
  )

  const languages = useSelector((state: Store) => state.app_meta.data.languages)

  // Set effectiveLanguageId
  useEffect(() => {
    let newELID = null
    if (isValidLanguageId(languages, languageId)) {
      let langObj = languageObject(languages, languageId)
      if (langObj) {
        newELID = langObj.id!
      }
    }
    setEffectiveLanguageId(newELID)
  }, [languageId, languages])

  // Handle missing data
  if (!effectiveLanguageId) {
    return null
  }

  return (
    <>
      <Helmet>
        <title>
          Preview: {survey.name_en}
          {titleTagSuffix}
        </title>
      </Helmet>

      <SurveyConfirmation languageId={effectiveLanguageId} survey={survey} />
    </>
  )
}
